



// import { useContext, useState, useEffect } from 'react';
// import { Eye, EyeOff, Lock, Mail, ArrowLeft, Shield, Users, BarChart3, AlertCircle } from 'lucide-react';
// import { Link, useNavigate } from 'react-router-dom';
// import AuthContext from '../context/AuthContext';
// import { useToast } from '../context/ToastContext'; 
// import Loader from '../components/Loader'; 

// export default function LoginPage() {
//   const { 
//     loginUser,
//     authError, 
//     clearError, 
//     isAuthenticated,
//     user,
//     isLoading,
//     loadingMessage,
//     loadingType 
//   } = useContext(AuthContext);

//   const navigate = useNavigate();
//   const { showError, showSuccess } = useToast(); // Use the toast hook

//   const [showPassword, setShowPassword] = useState(false);
//   const [formData, setFormData] = useState({
//     email: '',
//     password: '',
//     rememberMe: false
//   });

//   // Redirect if already authenticated
//   useEffect(() => {
//     if (isAuthenticated) {
//       showSuccess('Connexion réussie ! Redirection en cours...');
//       setTimeout(() => {
//         if (user.organization && user.roles && user.roles.length > 0) {
//             navigate("/dashboard");
//         }else{
//             showError("Informations sur l'organisation absentes ou sans rôle");
//             navigate("/login");
//         }
//       }, 1000);
        
//     }
//   }, [isAuthenticated, showSuccess]);

//     // Show error toast when authError changes
//   useEffect(() => {
//     if (authError) {
//       showError(authError);
//       // Clear the error from context after showing toast
//       if (clearError) clearError();
//     }
//   }, [authError, showError, clearError]);

//   // // Clear error when component mounts or when user starts typing
//   // useEffect(() => {
//   //   return () => {
//   //     if (clearError) clearError();
//   //   };
//   // }, [clearError]);

//   // Clear error when component unmounts
//     useEffect(() => {
//       return () => {
//         if (clearError) clearError();
//       };
//     }, [clearError]);

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
    
//     // Clear error when user starts typing
//     if (authError && clearError) {
//       clearError();
//     }
    
//     setFormData({
//       ...formData,
//       [name]: type === 'checkbox' ? checked : value
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     loginUser(e);
//   };



//   return (
//     <>
//       {/* Loader overlay */}
//       <Loader 
//         isVisible={isLoading}
//         message={loadingMessage}
//         type={loadingType}
//         variant="spinner"
//         size="medium"
//         overlay={true}
//       />

//       <div className="min-h-screen bg-gradient-to-br from-teal-400 via-blue-500 to-purple-600">
//         <div className="min-h-screen grid lg:grid-cols-2">
          
//           {/* Left Side - Visual Content (Hidden on mobile) */}
//           <div className="hidden lg:flex bg-gradient-to-br from-teal-500 via-blue-500 to-purple-600 p-8 lg:p-12 flex-col justify-center text-white relative overflow-hidden">
//             {/* Background decoration */}
//             <div className="absolute inset-0 opacity-10">
//               <div className="absolute top-20 left-10 w-32 h-32 bg-white rounded-full blur-xl"></div>
//               <div className="absolute bottom-20 right-10 w-40 h-40 bg-yellow-300 rounded-full blur-xl"></div>
//               <div className="absolute top-1/2 left-1/3 w-20 h-20 bg-pink-300 rounded-full blur-lg"></div>
//             </div>
            
//             <div className="relative z-10">
//               <div className="mb-8">
//                 <h1 className="text-4xl lg:text-5xl font-bold mb-4">
//                   Bienvenue sur
//                 </h1>
//                 <div className="text-3xl lg:text-4xl font-bold text-yellow-300 mb-6">
//                   Cartopousse
//                 </div>
//                 <p className="text-xl opacity-90 leading-relaxed mb-8">
//                   Votre plateforme de gestion des risques en toute sérénité
//                 </p>
//               </div>

//               {/* Features showcase */}
//               <div className="space-y-4">
//                 <div className="flex items-center space-x-3">
//                   <div className="bg-white bg-opacity-20 p-2 rounded-full">
//                     <Shield className="h-5 w-5" />
//                   </div>
//                   <span className="text-lg">Sécurité renforcée</span>
//                 </div>
//                 <div className="flex items-center space-x-3">
//                   <div className="bg-white bg-opacity-20 p-2 rounded-full">
//                     <BarChart3 className="h-5 w-5" />
//                   </div>
//                   <span className="text-lg">Dashboard dynamique</span>
//                 </div>
//                 <div className="flex items-center space-x-3">
//                   <div className="bg-white bg-opacity-20 p-2 rounded-full">
//                     <Users className="h-5 w-5" />
//                   </div>
//                   <span className="text-lg">Collaboration d'équipe</span>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Right Side - Login Form */}
//           <div className="bg-white p-8 lg:p-12 flex flex-col justify-center">
//             <div className="w-full max-w-md mx-auto">
              
//               {/* Back to home link */}
//               <div className="mb-8">
//                 <Link to="/" className="flex items-center text-gray-600 hover:text-teal-600 transition-colors group">
//                   <ArrowLeft className="h-4 w-4 mr-2 group-hover:-translate-x-1 transition-transform" />
//                   Retour à l'accueil
//                 </Link>
//               </div>

//               {/* Form Header */}
//               <div className="text-center mb-8">
//                 <h2 className="text-3xl font-bold text-gray-900 mb-2">Connexion</h2>
//                 <p className="text-gray-600">Accédez à votre tableau de bord</p>
//               </div>

              
 

//               {/* Login Form */}
//               <form onSubmit={handleSubmit}>
//                 <div className="space-y-6">
//                   <div>
//                     <label className="block text-gray-700 font-medium mb-2">Email</label>
//                     <div className="relative">
//                       <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                         <Mail className="h-5 w-5 text-gray-400" />
//                       </div>
//                       <input
//                         type="email"
//                         name="email"
//                         value={formData.email}
//                         onChange={handleInputChange}
//                         placeholder="votre@email.com"
//                         className={`w-full pl-10 pr-4 py-3 border rounded-lg focus:ring-2 focus:border-transparent transition-colors ${
//                           authError 
//                             ? 'border-red-300 focus:ring-red-500' 
//                             : 'border-gray-300 focus:ring-teal-500'
//                         }`}
//                         required
//                         disabled={isLoading}
//                         autoComplete="email"
//                       />
//                     </div>
//                   </div>

//                   <div>
//                     <label className="block text-gray-700 font-medium mb-2">Mot de passe</label>
//                     <div className="relative">
//                       <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                         <Lock className="h-5 w-5 text-gray-400" />
//                       </div>
//                       <input
//                         type={showPassword ? "text" : "password"}
//                         name="password"
//                         value={formData.password}
//                         onChange={handleInputChange}
//                         placeholder="Votre mot de passe"
//                         className={`w-full pl-10 pr-12 py-3 border rounded-lg focus:ring-2 focus:border-transparent transition-colors ${
//                           authError 
//                             ? 'border-red-300 focus:ring-red-500' 
//                             : 'border-gray-300 focus:ring-teal-500'
//                         }`}
//                         required
//                         disabled={isLoading}
//                         autoComplete="current-password"
//                       />
//                       <button
//                         type="button"
//                         onClick={() => setShowPassword(!showPassword)}
//                         className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 transition-colors disabled:opacity-50"
//                         disabled={isLoading}
//                       >
//                         {showPassword ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
//                       </button>
//                     </div>
//                   </div>

//                   <div className="flex justify-between">
//                     <div className="flex items-center">
//                       <input
//                         type="checkbox"
//                         name="rememberMe"
//                         checked={formData.rememberMe}
//                         onChange={handleInputChange}
//                         className="h-4 w-4 text-teal-600 focus:ring-teal-500 border-gray-300 rounded disabled:opacity-50"
//                         disabled={isLoading}
//                       />
//                       <label className="ml-2 text-sm text-gray-600">
//                         Se souvenir de moi
//                       </label>
//                     </div>
//                     <Link 
//                       to="/forgot-password" 
//                       className="text-sm text-teal-600 hover:text-teal-500 transition-colors"
//                     >
//                       Mot de passe oublié ?
//                     </Link>
//                   </div>

//                   <button
//                     type="submit"
//                     disabled={isLoading}
//                     className="w-full bg-gradient-to-r from-teal-500 to-blue-600 text-white py-3 rounded-lg font-semibold hover:shadow-lg transition-all duration-300 hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
//                   >
//                     {isLoading ? 'Connexion...' : 'Se connecter'}
//                   </button>
//                 </div>
//               </form>

//               {/* Divider */}
//               <div className="mt-8 mb-6">
//                 <div className="relative">
//                   <div className="absolute inset-0 flex items-center">
//                     <div className="w-full border-t border-gray-300"></div>
//                   </div>
//                   <div className="relative flex justify-center text-sm">
//                     <span className="px-2 bg-white text-gray-500">ou</span>
//                   </div>
//                 </div>
//               </div>


//               {/* Footer */}
//               <div className="mt-8 pt-6 border-t border-gray-100 text-center">
//                 <p className="text-xs text-gray-500">
//                   © 2025 Cartopousse - Tous droits réservés
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }





import { useContext, useState, useEffect } from 'react';
import { Eye, EyeOff, Lock, Mail, ArrowLeft, Shield, Users, BarChart3, AlertCircle } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import { useToast } from '../context/ToastContext'; 
import Loader from '../components/Loader'; 

export default function LoginPage() {
  const { 
    loginUser,
    authError, 
    clearError, 
    isAuthenticated,
    user,
    isLoading,
    loadingMessage,
    loadingType 
  } = useContext(AuthContext);

  const navigate = useNavigate();
  const { showError, showSuccess } = useToast();

  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false
  });

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      showSuccess('Connexion réussie ! Redirection en cours...');
      setTimeout(() => {
        if (user.organization && user.roles && user.roles.length > 0) {
            navigate("/dashboard");
        }else{
            showError("Informations sur l'organisation absentes ou sans rôle");
            navigate("/login");
        }
      }, 1000);
        
    }
  }, [isAuthenticated, showSuccess]);

  // Show error toast when authError changes
  useEffect(() => {
    if (authError) {
      showError(authError);
      if (clearError) clearError();
    }
  }, [authError, showError, clearError]);

  // Clear error when component unmounts
  useEffect(() => {
    return () => {
      if (clearError) clearError();
    };
  }, [clearError]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (authError && clearError) {
      clearError();
    }
    
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    loginUser(e);
  };

  return (
    <>
      {/* Loader overlay */}
      <Loader 
        isVisible={isLoading}
        message={loadingMessage}
        type={loadingType}
        variant="spinner"
        size="medium"
        overlay={true}
      />

      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-800">
        <div className="min-h-screen grid lg:grid-cols-2">
          
          {/* Left Side - Visual Content (Hidden on mobile) */}
          <div className="hidden lg:flex bg-gradient-to-br from-black via-gray-900 to-gray-800 p-8 lg:p-12 flex-col justify-center text-white relative overflow-hidden">
            {/* Background decoration */}
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-20 left-10 w-24 h-24 bg-green-500 rounded-full blur-xl"></div>
              <div className="absolute bottom-20 right-10 w-32 h-32 bg-green-400 rounded-full blur-xl"></div>
              <div className="absolute top-1/2 left-1/3 w-16 h-16 bg-green-300 rounded-full blur-lg"></div>
            </div>
            
            <div className="relative z-10">
              <div className="mb-8">
                <h1 className="text-3xl lg:text-4xl font-bold mb-3">
                  Bienvenue sur
                </h1>
                <div className="text-2xl lg:text-3xl font-bold text-green-400 mb-4">
                  Cartopousse
                </div>
                <p className="text-base opacity-90 leading-relaxed">
                  Votre plateforme de gestion des risques en toute sérénité
                </p>
              </div>

              {/* Features showcase */}
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <div className="bg-green-500 bg-opacity-20 p-2 rounded-lg">
                    <Shield className="h-4 w-4 text-green-400" />
                  </div>
                  <span className="text-sm">Sécurité renforcée</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="bg-green-500 bg-opacity-20 p-2 rounded-lg">
                    <BarChart3 className="h-4 w-4 text-green-400" />
                  </div>
                  <span className="text-sm">Dashboard dynamique</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="bg-green-500 bg-opacity-20 p-2 rounded-lg">
                    <Users className="h-4 w-4 text-green-400" />
                  </div>
                  <span className="text-sm">Collaboration d'équipe</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Login Form */}
          <div className="bg-white p-8 lg:p-12 flex flex-col justify-center">
            <div className="w-full max-w-md mx-auto">
              
              {/* Back to home link */}
              <div className="mb-6">
                <Link to="/" className="flex items-center text-gray-600 hover:text-green-600 transition-colors group text-sm">
                  <ArrowLeft className="h-4 w-4 mr-2 group-hover:-translate-x-1 transition-transform" />
                  Retour à l'accueil
                </Link>
              </div>

              {/* Form Header */}
              <div className="text-center mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-2">Connexion</h2>
                <p className="text-sm text-gray-600">Accédez à votre tableau de bord</p>
              </div>

              {/* Login Form */}
              <form onSubmit={handleSubmit}>
                <div className="space-y-5">
                  <div>
                    <label className="block text-gray-700 font-medium mb-2 text-sm">Email</label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <Mail className="h-4 w-4 text-gray-400" />
                      </div>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="votre@email.com"
                        className={`w-full pl-10 pr-4 py-2.5 text-sm border rounded-lg focus:ring-2 focus:border-transparent transition-colors ${
                          authError 
                            ? 'border-red-300 focus:ring-red-500' 
                            : 'border-gray-300 focus:ring-green-500'
                        }`}
                        required
                        disabled={isLoading}
                        autoComplete="email"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-gray-700 font-medium mb-2 text-sm">Mot de passe</label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <Lock className="h-4 w-4 text-gray-400" />
                      </div>
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        placeholder="Votre mot de passe"
                        className={`w-full pl-10 pr-12 py-2.5 text-sm border rounded-lg focus:ring-2 focus:border-transparent transition-colors ${
                          authError 
                            ? 'border-red-300 focus:ring-red-500' 
                            : 'border-gray-300 focus:ring-green-500'
                        }`}
                        required
                        disabled={isLoading}
                        autoComplete="current-password"
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 transition-colors disabled:opacity-50"
                        disabled={isLoading}
                      >
                        {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                      </button>
                    </div>
                  </div>

                  <div className="flex justify-between items-center">
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        name="rememberMe"
                        checked={formData.rememberMe}
                        onChange={handleInputChange}
                        className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded disabled:opacity-50"
                        disabled={isLoading}
                      />
                      <label className="ml-2 text-xs text-gray-600">
                        Se souvenir de moi
                      </label>
                    </div>
                    <Link 
                      to="/forgot-password" 
                      className="text-xs text-green-600 hover:text-green-500 transition-colors"
                    >
                      Mot de passe oublié ?
                    </Link>
                  </div>

                  <button
                    type="submit"
                    disabled={isLoading}
                    className="w-full bg-gradient-to-r from-green-600 to-green-700 text-white py-2.5 rounded-lg font-semibold text-sm hover:shadow-lg transition-all duration-300 hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                  >
                    {isLoading ? 'Connexion...' : 'Se connecter'}
                  </button>
                </div>
              </form>

              {/* Divider */}
              <div className="mt-8 mb-6">
                <div className="relative">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-gray-300"></div>
                  </div>
                  <div className="relative flex justify-center text-xs">
                    <span className="px-2 bg-white text-gray-500">ou</span>
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="mt-8 pt-6 border-t border-gray-100 text-center">
                <p className="text-xs text-gray-500">
                  © 2025 Cartopousse - Tous droits réservés
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}